export default function TeamSection() {
  const teamMembers = [
    {
      name: 'Daniel',
      role: 'Founder & Lead Painter',
      description: 'With over 18 years of experience in painting and decorating, Daniel founded Brushour with a vision to deliver exceptional craftsmanship and customer service across Hertfordshire.',
      image: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/cc9daa6af5f8b5c97e51d2fcd86d15c2.jpeg'
    },
    {
      name: 'Toni',
      role: 'Senior Decorator',
      description: 'Toni specializes in detailed finishing work and cleaning process. His meticulous attention to detail and creative eye ensure every project exceeds expectations.',
      image: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/860f251f5ea58f536e13df122e37da64.jpeg'
    },
    {
      name: 'Honey',
      role: 'Chief Morale Officer',
      description: 'Our adorable toy poodle is the official mascot of Brushour! While he doesn\'t actually join us on work sites, he brings plenty of smiles and represents the friendly, family atmosphere we bring to every project.',
      image: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/8d47bd6548f840b2e7c419026fa29119.jpeg',
      isMascot: true
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes pulse-dot {
          0%, 100% { opacity: 0.4; transform: scale(0.8); }
          50% { opacity: 1; transform: scale(1); }
        }
        .thought-balloon {
          animation: float 3s ease-in-out infinite;
        }
        .thought-dot-1 {
          animation: pulse-dot 2s ease-in-out infinite;
          animation-delay: 0s;
        }
        .thought-dot-2 {
          animation: pulse-dot 2s ease-in-out infinite;
          animation-delay: 0.3s;
        }
        .thought-dot-3 {
          animation: pulse-dot 2s ease-in-out infinite;
          animation-delay: 0.6s;
        }
      `}</style>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold text-amber-500 uppercase tracking-wider mb-2">Our Team</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Meet the Brushour Family
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">
            The dedicated professionals behind every beautiful transformation in Hertfordshire
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10 md:mt-24">
          {teamMembers.map((member, index) => (
            <div 
              key={index} 
              className={`group bg-gray-50 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 relative ${member.isMascot ? 'mt-20 md:mt-0' : ''}`}
              style={member.isMascot ? { overflow: 'visible' } : { overflow: 'hidden' }}
            >
              {member.isMascot && (
                <div className="absolute -top-20 left-1/2 -translate-x-1/2 z-50">
                  {/* Thought balloon */}
                  <div className="thought-balloon relative whitespace-nowrap">
                    <div className="bg-amber-400 text-white px-4 py-2 md:px-5 md:py-3 rounded-2xl shadow-lg relative">
                      <span className="font-bold text-base md:text-lg flex items-center gap-2">
                        <i className="ri-heart-fill text-white"></i>
                        Hi, I'm Honey!
                        <i className="ri-paw-print-fill text-white"></i>
                      </span>
                      {/* Balloon tail */}
                      <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-4 h-4 bg-amber-400 rotate-45"></div>
                    </div>
                  </div>
                  {/* Thought dots leading to mascot */}
                  <div className="flex flex-col items-center mt-1">
                    <div className="thought-dot-1 w-3 h-3 bg-amber-400 rounded-full mb-1"></div>
                    <div className="thought-dot-2 w-2 h-2 bg-amber-400 rounded-full mb-1"></div>
                    <div className="thought-dot-3 w-1.5 h-1.5 bg-amber-400 rounded-full"></div>
                  </div>
                </div>
              )}
              <div className="relative h-80 w-full overflow-hidden rounded-t-xl">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                {member.isMascot && (
                  <div className="absolute top-4 right-4 bg-amber-400 text-white text-xs font-semibold px-3 py-1 rounded-full flex items-center gap-1">
                    <i className="ri-heart-fill"></i>
                    Mascot
                  </div>
                )}
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-1">{member.name}</h3>
                <p className="text-sm font-medium text-amber-500 mb-3">{member.role}</p>
                <p className="text-sm text-gray-600 leading-relaxed">{member.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <div className="inline-flex items-center gap-3 bg-amber-50 px-6 py-4 rounded-lg">
            <i className="ri-team-fill text-2xl text-amber-500"></i>
            <p className="text-sm text-gray-700">
              <strong className="text-gray-800">Family-run business</strong> — We treat every home like our own
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
